<template>
  <div>
    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      :title="plotTitle"
      @close="close"
      width="50%"
      append-to-body
    >
      <el-form
        :model="form"
        ref="form"
        :rules="rules"
        label-position="left"
        label-width="100px"
      >
        <el-form-item prop="dspId" label="投放预算">
          <el-select
            v-model="form.dspId"
            placeholder="请选择"
            style="width: 100%"
            :visible-change="selectData()"
          >
            <template v-for="(item, index) in dspData" :key="index">
              <el-option :label="item.dspName" :value="item.dspId"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="对应广告位" prop="dspSlotId">
          <el-select
            v-model="form.dspSlotId"
            placeholder="请选择广告位"
            style="width: 100%"
          >
            <template v-for="(item, index) in dspSlotData" :key="index">
              <el-option
                :label="item.dspSlotName"
                :value="item.dspSlotId"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="计划名称" prop="planName">
          <el-input v-model="form.planName"></el-input>
        </el-form-item>
        <el-form-item label="预算控制方式" prop="controlWay">
          <el-radio-group v-model="form.controlWay">
            <el-radio :label="1">控制展示量</el-radio>
            <el-radio :label="2">控制点击量</el-radio>
            <el-radio :label="3">控制唤醒量</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="日量级" prop="dailyWeight">
          <el-input v-model="form.dailyWeight"></el-input>
        </el-form-item>
        <el-form-item label="投放时间">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="开始时间"
            style="margin-right: 10px"
          />
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="结束时间"
          />
        </el-form-item>
        <el-form-item label="投放时段">
          <el-date-picker
            v-model="putTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="均匀投放">
          <el-switch
            v-model="form.isEvenly"
            active-color="#13ce66"
            active-value="1"
            inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="投放机型">
          <el-checkbox  v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="model"  @change="handleCheckedCitiesChange">
            <template v-for="(item, index) in brandData" :key="index">
              <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
            </template>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="投放方式">
          <el-radio v-model="form.putWay" label="0">通投</el-radio>
          <el-radio v-model="form.putWay" label="1">定向投放</el-radio>
        </el-form-item>
        <el-form-item label="上传人群包" prop="testUrl">
        <el-upload
           class="avatar-uploader"
          :action="$baseURL + 'common/upload/file'"
          :headers="header"
          list-type="text"
          :auto-upload="false"
          :on-success="onSuccess"
          accept="text/*">
           <el-button  type="primary">上传文件<el-icon class="el-icon--right"><Upload /></el-icon></el-button>
        </el-upload>
      </el-form-item>
        <div v-if="form.planId">
          <el-form-item label="投放媒体">
            <div>
              <el-button size="small" type="success" @click="onShow" style="margin-right: 10px;">展开所有</el-button>
            </div>
            <el-tag
              :key="tag"
              v-for="tag in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              disabled="true"
              >添加</el-button
            >
          </el-form-item>
        </div>
      </el-form>
      <div style="text-align: right">
        <el-button @click="close" size="medium">取消</el-button>
        <el-button
          @click="submit"
          type="primary"
          size="medium"
          :loading="submitLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addplot,
  getdataplot,
  selectDsp,
  selectData,
  upDataPlot,
  getBrand,
} from "@/api/manage/plot/plot";
import { mapGetters } from 'vuex'

const form = {
  controlWay: undefined,
  dailyWeight: undefined,
  dspId: undefined,
  dspSlotId: undefined,
  planName: undefined,
  startTime: undefined,
  isEvenly: undefined,
  modelIds: undefined,
  putWay: undefined,
  putTime: undefined,
  testUrl: undefined,
  slotPlanMediaRes: undefined,
  modelResList:undefined,
};
export default {
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      rules: {
        dspId: [{ required: true, message: '请选择投放预算', trigger: 'blur' }],
        planName: [{ required: true, message: '请输入计划名称', trigger: 'blur' }],
        dspSlotId: [{ required: true, message: '请选择广告位', trigger: 'blur' }],
        controlWay: [{ required: true, message: '请选择预算控制方式', trigger: 'blur' }]
      },
      dynamicTags: undefined,
      inputVisible: false,
      inputValue: '',
      dspSlotData: undefined,
      dspData: undefined,
      brandData: undefined,
      model: [],
      header: {},
      checkAll: false
    }
  },

  created () {
    this.header = {
      Authorization: 'Bearer ' + this.access_token
    }
  },
  mounted () {
    selectDsp().then((res) => {
      if (res.code === 200) {
        this.dspData = res.data
      }
    })
    getBrand().then((res) => {
      if (res.code == 200) {
        this.brandData = res.data
      }
    })
  },
  computed: {
    plotTitle () {
      return (this.form.planId ? '修改' : '新增') + '广告计划'
    },
    ...mapGetters([
      'access_token'
    ])
  },
  methods: {
    show (data) {
      if (data) {
        const id = {
          planId: data.planId
        }
        getdataplot(id).then((res) => {
          if (res.code === 200) {
            this.form = Object.assign({}, res.data)
            const tags = this.form.slotPlanMediaRes.map((item) => { return item.dspSlotName })
            this.dynamicTags = tags.slice(0, 10)
            this.modeBy()
          }
        })
      }
      this.dialogStatus = true
    },
    onShow () {
      if (this.dynamicTags.length < 11) {
        this.dynamicTags = this.form.slotPlanMediaRes.map((item) => { return item.dspSlotName })
      } else {
        this.dynamicTags = this.dynamicTags.slice(0, 10)
      }
    },
    close () {
      this.reset()
      this.dialogStatus = false
    },
    reset () {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    },
    modeBy () {
      this.model = this.form.modelResList.map((item) => {
        return item.id
      })
    },
    submit () {
      this.$refs.form.validate((valid) => {
        if (this.validate() && valid) {
          if (this.form.modelIds) {
            this.form.modelIds = undefined
            for (let i = 0; i < this.model.length; i++) {
              this.form.modelIds = this.form.modelIds + this.model[i] + ','
            }
          } else {
            for (let i = 0; i < this.model.length; i++) {
              this.form.modelIds = this.form.modelIds + this.model[i] + ','
            }
          }
          if (this.form.planId) {
            this.upDataPlot(this.form)
          } else {
            this.addplot(this.form)
          }
        }
      })
    },
    addplot (form) {
      this.submitLoading = true
      addplot(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('新增成功')
            this.$emit('submit')
            this.close()
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    upDataPlot (form) {
      this.submitLoading = true
      upDataPlot(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('编辑成功')
            this.$emit('submit')
            this.close()
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    selectData () {
      const dsp = { dspId: this.form.dspId }
      selectData(dsp).then((res) => {
        if (res.code === 200) {
          this.dspSlotData = res.data
        }
      })
    },
    onSuccess (res) {
      if (res.code === 200) {
        this.form.testUrl = res.data[0] || ''
      }
    },
    validate () {
      if (!this.form.testUrl) {
        this.$message.warning('请上传人群包')
        return
      }
      return true
    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
      this.slotPlanMediaRes.splice(this.slotPlanMediaRes.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      // this.$nextTick((_) => {
      //   this.$refs.saveTagInput.$refs.input.focus();
      // });
    },
    handleInputConfirm () {
      const inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push()
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleCheckAllChange (val) {
      this.model = val ? this.brandData.map((item) => {
        return item.id
      }) : []
    },
    handleCheckedCitiesChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.brandData.length
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
.form-label {
  display: block;
  line-height: 20px;
}
.form-item__label {
  line-height: 20px;
  text-align: center;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
// /deep/ .el-upload {
//   border: 1px dashed #d9d9d9;
//   border-radius: 6px;
//   cursor: pointer;
//   position: relative;
//   overflow: hidden;
// }
// /deep/ .el-upload:hover {
//   border-color: #409eff;
// }
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
